/* CUBE STORE - pagina prodotto
   1) rende richiudibile la sezione "Specifiche tecniche" (app Tably);
   2) sposta il nome del colore dal titolo a una riga sotto, piccola e grigia,
      e le affianca codice articolo e marca;
   3) toglie la marca "CUBE" dalla testa del titolo;
   4) tiene in vista il fondo della colonna di destra quando e' piu' alta
      della finestra;
   5) porta la matrice - il percorso di categoria - sopra al titolo;
   6) mette il widget seQura fra HeyLight e il buono, e lo mostra solo fra
      499 e 3000 euro;
   7) rimette in funzione seQura, che si spegne su tutto il negozio a ogni
      pubblicazione di un tema. */
(function () {
  /* ---------- 1. specifiche tecniche richiudibili ---------- */
  /* L'elenco delle specifiche viene spostato dentro un pannello e al suo
     posto compare un'intestazione cliccabile, con lo stesso aspetto degli
     altri riquadri della colonna ("Metodi di pagamento", "Calcola la tua
     taglia"). Il titolo originale dell'app viene nascosto: la nostra
     intestazione lo sostituisce, riusandone il testo cosi' se l'app cambia
     lingua il riquadro la segue. */

  function build() {
    var rows = document.querySelector('.tably-spec-premium-rows');
    if (!rows || rows.dataset.cubeAccordion === '1') return;

    var list = rows.querySelector('.tably-spec-premium-rows__list');
    if (!list) return;

    rows.dataset.cubeAccordion = '1';

    var title = rows.querySelector('.tably-spec-premium-rows__title');
    var label = title && title.textContent.trim() ? title.textContent.trim() : 'Specifiche tecniche';
    if (title) title.style.display = 'none';

    var accordion = document.createElement('div');
    accordion.className = 'cube-specs-accordion';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cube-specs-trigger';
    button.setAttribute('aria-expanded', 'false');

    var text = document.createElement('span');
    text.textContent = label;

    var icon = document.createElement('span');
    icon.className = 'cube-specs-trigger__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '+';

    button.appendChild(text);
    button.appendChild(icon);

    var panel = document.createElement('div');
    panel.className = 'cube-specs-panel';
    panel.hidden = true;

    rows.insertBefore(accordion, list);
    accordion.appendChild(button);
    accordion.appendChild(panel);
    panel.appendChild(list);

    button.addEventListener('click', function (event) {
      event.preventDefault();
      var isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.hidden = isOpen;
    });
  }

  /* ---------- 2. colore, codice e marca sotto il titolo ---------- */
  /* Il colore non e' un dato a parte: il metafield "custom.colore" e' vuoto
     sui prodotti, quindi si ricava dal titolo sfruttando la convenzione CUBE,
     dove il colore e' sempre l'ultima parola:
       - se contiene "n" fra due accenti (topasblue´n´white) e' senz'altro un
         colore;
       - altrimenti vale come colore solo se e' tutta minuscola, lunga almeno
         5 lettere e senza cifre (teamline, actionteam, carbon). I nomi dei
         modelli CUBE sono maiuscoli o contengono numeri, quindi restano.
     Se nessuna delle due condizioni e' vera il titolo resta intero.

     Perche' in JavaScript e non in Liquid: il titolo della pagina prodotto
     non passa dal blocco "product-title" del tema (quello disegna i titoli
     delle schede) ma da un blocco di testo generico, dove non si puo'
     mettere logica.

     La riga va inserita FUORI dal contenitore ".text-block" del titolo:
     dentro erediterebbe la tipografia del blocco (32px, peso 700, nera) e
     le regole del tema batterebbero la classe da sola.

     L'H1 viene cercato solo nella pagina prodotto e solo se non e' dentro una
     scheda, per non toccare i titoli del carosello in fondo. */

  function isProductPage() {
    var main = document.getElementById('MainContent');
    return !!main && main.dataset.template === 'product';
  }

  /* Il codice articolo, a differenza di colore e marca, NON si ricava dal
     titolo: e' il metafield custom.codice. Da qui il Liquid non si
     raggiunge, quindi il blocco "Widget pagamenti" lo stampa in un nodo
     nascosto e noi lo leggiamo da li'. Se il prodotto non ce l'ha, il nodo
     e' vuoto e la riga resta com'era. */
  function productCode() {
    var node = document.getElementById('cube-dati-prodotto');
    return node ? (node.getAttribute('data-codice') || '').trim() : '';
  }

  function splitColor(title) {
    var words = title.trim().split(/\s+/);
    if (words.length < 2) return null;

    var last = words[words.length - 1];

    if (last.indexOf('´n´') === -1) {
      if (last !== last.toLowerCase()) return null;
      if (last.length < 5) return null;
      if (/[0-9]/.test(last)) return null;
    }

    return { title: words.slice(0, -1).join(' '), color: last };
  }

  /* La marca e' la PRIMA parola, e vale solo se e' esattamente "CUBE".
     Il confronto ignora maiuscole e minuscole perche' in amministrazione i
     titoli sono scritti in entrambi i modi ("CUBE AGREE C:62 EX" e "Cube
     Stereo Hybrid ONE44"); la resa maiuscola la fa poi il CSS.

     Il vincolo sulla parola esatta serve a lasciare interi titoli come
     "SCARPE CUBE GTY STRIX", dove CUBE non e' in apertura, e a non svuotare
     il titolo quando la marca e' l'unica parola rimasta. */

  function splitBrand(title) {
    var words = title.trim().split(/\s+/);
    if (words.length < 2) return null;
    if (words[0].toUpperCase() !== 'CUBE') return null;

    return { brand: words[0], title: words.slice(1).join(' ') };
  }

  /* Il titolo dell'H1 va ripulito comunque - la marca in testa esce dal
     titolo anche quando l'occhiello non viene disegnato - ma l'occhiello si
     disegna solo se NON c'e' la matrice. Sopra al titolo c'e' spazio per una
     riga sola, e su un negozio monomarca il percorso dice molto piu' di
     "CUBE": vedi la nota in assets/cube-matrice.css. */
  function cePercorso() {
    return !!document.querySelector('.cube-matrice');
  }

  function colorLine() {
    if (!isProductPage()) return;

    var codice = productCode();

    var heads = document.querySelectorAll('h1');
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      if (h.dataset.cubeColor === '1') continue;
      if (h.closest('product-card, .resource-card, .card, .spf-product-card')) continue;

      h.dataset.cubeColor = '1';

      /* prima si toglie il colore in coda, poi la marca in testa: le due
         operazioni sono indipendenti e ognuna puo' non applicarsi */
      var parts = splitColor(h.textContent);
      var titolo = parts ? parts.title : h.textContent;

      var marca = splitBrand(titolo);
      if (marca) titolo = marca.title;

      if (!parts && !marca && !codice) continue;
      h.textContent = titolo;

      /* fuori dal blocco di testo, e fuori dall'eventuale link del titolo */
      var anchor = h.closest('.text-block') || h.closest('a') || h;
      var host = anchor.parentElement;
      if (!host) continue;

      if (marca && !cePercorso()) {
        var riga = document.createElement('p');
        riga.className = 'cube-pdp-marca';
        riga.textContent = marca.brand;
        host.insertBefore(riga, anchor);
      }

      /* la riga sotto il titolo esiste se c'e' almeno uno dei due: un
         prodotto senza colore ma con codice deve comunque mostrarlo */
      if (parts || codice) {
        var line = document.createElement('p');
        line.className = 'cube-pdp-colore';

        if (parts) line.appendChild(document.createTextNode(parts.color));

        if (codice) {
          var cod = document.createElement('span');
          cod.className = 'cube-pdp-codice';

          /* LA MARCA DOPO IL CODICE, chiesta il 17 agosto 2026 "che ci aiuta
             per google", e messa a destra del numero su indicazione
             dell'utente: prima il numero seriale, poi CUBE.

             Da quando la matrice ha preso il posto dell'occhiello, la parola
             CUBE non compariva piu' da nessuna parte nel testo della pagina:
             il titolo la perde (punto 3) e l'occhiello non si disegna. Il
             tag <title> e i meta ce l'hanno ancora - li' scrive Shopify, non
             noi - ma nel corpo della pagina no.

             La condizione e' la stessa che toglie la marca dal titolo: cosi'
             non si scrive CUBE su una gomma Schwalbe o un casco di un'altra
             marca, dove splitBrand non scatta.

             Da sapere, senza illudersi: questo testo lo scrive JavaScript.
             Google esegue gli script e lo legge, ma un testo stampato dal
             server pesa di piu'. Se un giorno la SEO diventa una priorita'
             vera, questa riga andrebbe spostata in Liquid insieme a colore e
             codice - e' un lavoro a se', non una riga. */
          cod.textContent = marca ? codice + ' ' + marca.brand.toUpperCase() : codice;

          line.appendChild(cod);
        }

        host.insertBefore(line, anchor.nextSibling);
      }
    }
  }

  /* ---------- 7. seQura si spegne a ogni pubblicazione: qui si riaccende ---------- */
  /* IL GUASTO, MISURATO IL 18 AGOSTO 2026 SUBITO DOPO LA PUBBLICAZIONE DI V3.3.
     Sul sito non compariva nessun widget seQura. Non fuori posto: assente,
     zero nodi in pagina, su tutti i prodotti provati.

     L'app cerca il prezzo con un selettore che si e' salvata quando l'hanno
     configurata, e quel selettore contiene l'identificativo del MODELLO DI
     PAGINA, che e' diverso in ogni tema:

       cercava   #ProductInformation-template--29952159973759__main .price-item--sale
       esisteva  #ProductInformation-template--29960437727615__main

     Il primo numero era il modello di V3.2. Pubblicando V3.3, Shopify ne ha
     generato uno nuovo e il selettore ha smesso di trovare il prezzo. Senza
     prezzo l'app non disegna niente.

     E' quasi certamente la spiegazione della notte fra il 17 e il 18 agosto,
     quando la configurazione dell'app e' cambiata quattro volte: ogni
     pubblicazione la rompeva e qualcuno la riagganciava a mano al tema del
     momento. Con questo pezzo non serve piu'.

     IL RIMEDIO. Se il selettore dell'app non trova niente e noi invece
     sappiamo dov'e' il prezzo, glielo correggiamo e gli chiediamo di
     ridisegnare. Il selettore che gli diamo NON contiene identificativi di
     tema, quindi sopravvive a tutte le pubblicazioni future.

     Provato sul sito vero prima di scriverlo: da 0 widget a 1, importo
     169900 giusto per una bici da 1.699 euro, e finito da solo dentro
     .cube-widget-sequra grazie al punto 6.

     TRE CAUTELE.
     - Si tocca solo se e' rotto: se il selettore dell'app trova il prezzo,
       qui non succede niente. Il giorno in cui lo sistemano nell'app, questo
       pezzo si fa da parte da solo.
     - Si disegna UNA VOLTA SOLA per pagina (la spia "riparata"): senza,
       drawWidgetsOnPage creerebbe nodi, l'osservatore ci farebbe rientrare
       qui e si ricomincerebbe da capo a ogni frame.
     - querySelector con un selettore malformato solleva un'eccezione, e
       quello viene dall'app, non da noi: da qui il try. Un'eccezione non
       gestita fermerebbe tutto il resto del file. */

  var SEQURA_PREZZO = '.product-details .price-item--sale';
  var sequraRiparata = false;

  function ceQualcosa(selettore) {
    if (!selettore) return false;
    try {
      return !!document.querySelector(selettore);
    } catch (e) {
      return false;
    }
  }

  function sequraSelettore() {
    if (sequraRiparata) return;

    var app = window.SequraWidgetFacade;
    if (!app || !app.widgets || !app.widgets.length) return;

    /* se il prezzo non lo troviamo nemmeno noi, non siamo in una scheda
       prodotto: non c'e' niente da riparare e niente da indovinare */
    if (!ceQualcosa(SEQURA_PREZZO)) return;

    var rotto = false;
    for (var i = 0; i < app.widgets.length; i++) {
      var w = app.widgets[i];
      if (w.priceSel && !ceQualcosa(w.priceSel)) {
        w.priceSel = SEQURA_PREZZO;
        rotto = true;
      }
    }
    if (!rotto) return;

    sequraRiparata = true;
    if (typeof app.drawWidgetsOnPage === 'function') {
      try {
        app.drawWidgetsOnPage();
      } catch (e) {
        /* se l'app cambia nome ai suoi metodi, il sito resta in piedi:
           si perde il widget, non la pagina */
      }
    }
  }

  /* ---------- 6. il widget seQura: posto e fascia di prezzo ---------- */
  /* Chiesto il 18 agosto 2026 in due tempi - prima il limite di prezzo, poi
     la posizione. Il perche' per esteso sta in assets/cube-sequra.css: qui
     ci sono le due decisioni.

     LA FASCIA. seQura non ha limiti impostati nell'app, e su una bici da
     8.490 euro proponeva 269 euro al mese con un primo pagamento di 5.759,
     cioe' un anticipo piu' alto di due terzi del prezzo. Estremi compresi.

     L'IMPORTO SI LEGGE DAL WIDGET, non dal tema. Ogni
     div.sequra-promotion-widget porta il suo data-amount in centesimi
     (849000 = 8.490 euro): e' il dato che seQura stessa userebbe per il
     calcolo. Le soglie qui sotto sono in centesimi perche' in centesimi
     arriva il dato: nessuna divisione, nessun arrotondamento.

     IL POSTO. L'app lo appendeva dentro i tasti d'acquisto, cioe' sotto
     AGGIUNGI AL CARRELLO e staccato dagli altri due modi di pagare. Qui
     viene riportato dentro .cube-widget-sequra, il contenitore che sta
     esattamente fra HeyLight e il buono.

     IL DOPPIONE SUCCEDE DAVVERO, AL CAMBIO TAGLIA. Misurato: cliccando una
     taglia, seQura non aggiorna il widget che abbiamo spostato - ne fa un
     secondo nei tasti d'acquisto, e restano tutti e due. Con questo codice
     il secondo viene marcato e sparisce: in pagina se ne vede sempre uno.

     LE COPIE ALTROVE NON SI TOCCANO. Sulla scheda prodotto i widget possono
     essere sei: uno nel prezzo e cinque dentro le schede della ricerca
     predittiva, nascoste. Il limite di prezzo vale per tutti, ognuno col suo
     importo; lo spostamento no, e le copie si riconoscono dal contenitore in
     cui vivono.

     PERCHE' UN DOPPIONE SI NASCONDE INVECE DI CANCELLARLO: cancellare un
     nodo dell'app rischia di farglielo ricreare, e si finirebbe a
     rincorrersi a ogni frame. Marcarlo e lasciarlo li' invisibile costa
     niente e non innesca niente. */

  var SEQURA_MIN = 49900;
  var SEQURA_MAX = 300000;

  /* Le finestre "Scegli" dei prodotti consigliati montano un modulo
     d'acquisto completo, tasti compresi, e seQura ci infila dentro il widget
     di QUEL prodotto - misurato il 18 agosto. Non stando dentro una scheda,
     senza "quick-add-dialog" in questo elenco finirebbe fra i candidati allo
     spostamento, e sotto HeyLight potrebbe comparire il prezzo di un'altra
     bici. */
  var SEQURA_ALTROVE = '.resource-card, .predictive-search-results, .spf-product-card, product-card, quick-add-dialog, dialog';

  function sequra() {
    var casa = document.querySelector('.cube-widget-sequra');
    var widget = document.querySelectorAll('.sequra-promotion-widget');

    for (var i = 0; i < widget.length; i++) {
      var w = widget[i];

      /* la fascia di prezzo, per tutte le copie */
      var cent = parseInt(w.getAttribute('data-amount'), 10);
      var dentro = !isNaN(cent) && cent >= SEQURA_MIN && cent <= SEQURA_MAX;
      w.classList.toggle('cube-sequra-fuori', !dentro);

      /* il posto, solo per quella del prodotto */
      if (!casa) continue;
      if (w.closest(SEQURA_ALTROVE)) continue;

      if (w.parentElement === casa) {
        w.classList.remove('cube-sequra-doppio');
      } else if (casa.querySelector('.sequra-promotion-widget')) {
        w.classList.add('cube-sequra-doppio');
      } else {
        casa.appendChild(w);
        w.classList.remove('cube-sequra-doppio');
      }
    }
  }

  /* ---------- 5. la matrice sopra al titolo ---------- */
  /* Il percorso di categoria lo costruisce snippets/cube-matrice.liquid, che
     lo ricava incrociando le collezioni del prodotto con il menu di
     navigazione. Da Liquid pero' non si puo' scrivere sopra al titolo, per
     lo stesso motivo spiegato al punto 2: il titolo esce da un blocco di
     testo generico. Quindi il pezzo nasce dove capita nella pagina, gia'
     pronto e con l'attributo hidden, e qui viene portato al suo posto.

     L'hidden si toglie DOPO lo spostamento, mai prima: altrimenti per un
     istante si vedrebbe comparire in fondo alla pagina.

     Il segno sul nodo (dataset.cubePosata) non e' un dettaglio: questo
     script gira a ogni modifica del DOM tramite MutationObserver, e
     spostare un nodo e' a sua volta una modifica. Senza il segno, si
     rientrerebbe qui all'infinito. */

  function matrice() {
    if (!isProductPage()) return;

    var nav = document.querySelector('.cube-matrice');
    if (!nav || nav.dataset.cubePosata === '1') return;

    var heads = document.querySelectorAll('h1');
    var h = null;
    for (var i = 0; i < heads.length; i++) {
      if (heads[i].closest('product-card, .resource-card, .card, .spf-product-card')) continue;
      h = heads[i];
      break;
    }
    if (!h) return;

    var anchor = h.closest('.text-block') || h.closest('a') || h;
    var host = anchor.parentElement;
    if (!host) return;

    nav.dataset.cubePosata = '1';
    host.insertBefore(nav, anchor);
    nav.hidden = false;

    /* se l'occhiello della marca era gia' stato disegnato in un giro
       precedente, adesso la riga e' della matrice */
    var vecchia = host.querySelector('.cube-pdp-marca');
    if (vecchia) vecchia.remove();
  }

  /* ---------- 4. colonna destra piu' alta della finestra ---------- */
  /* Il tema tiene ferma la colonna dei dettagli con position: sticky mentre
     la galleria a sinistra scorre. Funziona finche' la colonna ci sta nello
     schermo: quando e' piu' alta, sticky la incolla dal bordo ALTO e quello
     che avanza in fondo resta fuori vista per tutta la durata dello
     scorrimento della galleria.

     Rimedio: invece di incollarla in alto la si tira su di quanto sborda,
     cosi' si ferma con il fondo - tasto d'acquisto, calcolo taglia,
     specifiche - in vista mentre la galleria continua a scorrere.

     IL LIMITE ALLA TESTATA, TOLTO IL 9 AGOSTO 2026
     Fino a ieri la colonna non poteva salire sopra il bordo inferiore della
     testata: si voleva tenere sempre visibile il titolo del prodotto. Il
     conto pero' non tornava. Misurato su una finestra alta 720 con colonna
     alta 727: servivano 162px di risalita, il limite ne concedeva 16, e il
     fondo restava 140px sotto il bordo dello schermo - irraggiungibile
     finche' non finivano tutte le foto, cioe' dopo 2.800px di galleria.
     Segnalato da Maura: "se voglio scendere in calcola la tua taglia devono
     prima scorrere tutte le foto".

     Ora la risalita non ha piu' quel tetto: la colonna si ferma con il fondo
     dentro lo schermo, qualunque sia la sua altezza.

     Cosa si e' scelto di perdere: su finestre basse le prime righe della
     colonna - matrice, titolo, colore e codice - scorrono sotto la testata
     mentre si guarda la galleria. Tornano appena si risale, e il titolo
     resta comunque scritto nella scheda del browser e nella galleria
     accanto. Vale meno del poter arrivare al tasto d'acquisto.

     Il top del tema va letto, non dato per scontato: lo porta la variabile
     --sticky-header-offset, che vale l'altezza della testata piu' un po'
     d'aria. Si legge togliendo il nostro valore, misurando e rimettendolo
     subito, tutto dentro lo stesso frame: nessun ridisegno in mezzo,
     quindi nessun sfarfallio.

     Va ricalcolato a ogni cambio di altezza della colonna (l'accordion
     delle specifiche che si apre, la guida taglie, i riquadri che le app
     aggiungono dopo il caricamento) e a ogni ridimensionamento della
     finestra. Il ResizeObserver non entra in ciclo perche' cambiare il top
     non cambia l'altezza dell'elemento osservato. */

  /* aria fra il fondo della colonna e il bordo basso della finestra */
  var STACCO_FONDO = 16;

  function colonnaDettagli() {
    return document.querySelector('.product-details.sticky-content--desktop');
  }

  function topDelTema(el) {
    var mio = el.style.getPropertyValue('top');
    var priorita = el.style.getPropertyPriority('top');
    el.style.removeProperty('top');
    var valore = parseFloat(getComputedStyle(el).top);
    if (mio) el.style.setProperty('top', mio, priorita);
    return isNaN(valore) ? 0 : valore;
  }

  function adattaColonna() {
    var el = colonnaDettagli();
    if (!el) return;

    /* sotto i 750px la colonna non e' appiccicata: niente da correggere */
    if (getComputedStyle(el).position !== 'sticky') {
      el.style.removeProperty('top');
      return;
    }

    var base = topDelTema(el);
    var sbordo = el.offsetHeight + base + STACCO_FONDO - window.innerHeight;

    if (sbordo <= 0) {
      el.style.removeProperty('top');
      return;
    }

    /* si tira su di quanto sborda: il fondo si ferma a STACCO_FONDO dal
       bordo basso della finestra. Il valore puo' venire negativo, ed e'
       giusto - vuol dire che la testa della colonna passa sotto la testata. */
    el.style.setProperty('top', base - sbordo + 'px', 'important');
  }

  function osservaColonna() {
    var el = colonnaDettagli();
    if (!el || el.dataset.cubeSticky === '1') return;
    el.dataset.cubeSticky = '1';
    if (typeof ResizeObserver !== 'function') return;
    new ResizeObserver(function () {
      requestAnimationFrame(adattaColonna);
    }).observe(el);
  }

  /* ---------- avvio ---------- */
  /* La matrice va prima di colorLine: cosi' quando colorLine decide se
     disegnare l'occhiello della marca, il percorso e' gia' in pagina e la
     risposta e' no.

     E la riparazione del selettore va prima di sequra(): se il widget e'
     appena stato ridisegnato, lo troviamo nello stesso giro e lo mettiamo
     subito al suo posto, senza che si veda passare dai tasti d'acquisto. */

  var queued = false;
  function run() {
    queued = false;
    build();
    matrice();
    colorLine();
    sequraSelettore();
    sequra();
    osservaColonna();
    adattaColonna();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  }

  function init() {
    run();
    window.addEventListener('resize', schedule);

    /* il cambio di taglia puo' cambiare il prezzo: la casella che cambia
       non e' una modifica del DOM, quindi l'osservatore da solo non
       basterebbe */
    document.addEventListener('change', schedule);

    if (!document.body) return;

    /* childList per i pezzi che nascono e si spostano, piu' data-amount
       perche' seQura aggiorna quell'attributo quando cambia il prezzo.
       L'elenco degli attributi osservati e' volutamente stretto: se ci
       fosse dentro "class", il nostro stesso toggle farebbe ripartire
       l'osservatore a ogni giro. */
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributeFilter: ['data-amount']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
